import React from "react";
import { Page, Toolbar, BackButton, Card } from "react-onsenui";

export default class ThreatPage extends React.Component {
  renderToolbar() {
    const { navigator, threat } = this.props;
    return (
      <Toolbar navigator={navigator}>
        <div className="left">
          <BackButton />
        </div>
        <div className="center">{`${threat[0]}`}</div>
      </Toolbar>
    );
  }

  render() {
    const { threat } = this.props;
    return (
      <Page renderToolbar={this.renderToolbar.bind(this)}>
        <Card>{threat[1]}</Card>
      </Page>
    );
  }
}
